import { LoadingButton } from "@mui/lab";
import { usePaystackPayment } from "react-paystack";

export default function PaystackPayment({
  config,
  onSuccess,
  onClose,
  loading,
}) {
  const initializePayment = usePaystackPayment(config);
  return (
    <LoadingButton
      fullWidth
      sx={{
        ".MuiLoadingButton-loadingIndicatorCenter": {
          color: "white !important",
        },
        borderRadius: "10px",
        bgcolor: "var(--c-primary-1) !important",
        "&:hover": { bgcolor: "var(--c-primary-1) !important" },
      }}
      size="large"
      onClick={() => {
        initializePayment(onSuccess, onClose);
      }}
      loading={loading}
      variant="contained"
    >
      <span>Proceed to Pay</span>
    </LoadingButton>
  );
}
